import AnonBookedReplyDto from "@/models/AnonBookingRoleWorkers/AnonBookedReplyDto";
import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateAnonWorkerBookingOfferRequest extends BaseUpdateRequest
{ 
    replies: AnonBookedReplyDto[];
}